import React from "react";
import SwipeBtn from "../swipebutton/SwipeBtn";

function GenderButton({
  adult,
  one,
  two,
  onChange,
}: {
  adult: boolean;
  one: string;
  two: string;
  onChange: () => void;
}) {
  return (
    <div className="flex items-center justify-center gap-4">
      <span className={`text-sm font-semibold transition-colors ${adult ? "text-primary" : "text-slate-400 dark:text-slate-500"}`}>
        {one}
      </span>
      <SwipeBtn checked={adult} onChange={onChange} />
      <span className={`text-sm font-semibold transition-colors ${!adult ? "text-primary" : "text-slate-400 dark:text-slate-500"}`}>
        {two}
      </span>
    </div>
  );
}

export default GenderButton;
